import * as _ from 'lodash'
import { Subject } from 'rxjs'
import { debounceTime } from 'rxjs/operators'
import { defineComponent } from 'vue'
import { faCircleNotch, faBarcode } from '@fortawesome/free-solid-svg-icons'

import { Item, Container } from '@skinsoft/types'
import { itemSelectors } from '@skinsoft/selectors'
import { containerSelectors } from '@skinsoft/entity-ui'

import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { BarcodeSubscriber, ItemCard } from '@skinsoft/ui'
import { BarcodeReader } from '../..'

require('./all-item-display-form.scss')

export interface Values {
    location: string
    identifier: string
}

// number of items per search results page
const PAGE_SIZE = 15

export const AllItemDisplayForm = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sBarcodeReader: BarcodeReader,
        sBarcodeSubscriber: BarcodeSubscriber,
        sItemCard: ItemCard,
    },
    props: {
        canChainAdd: Boolean,
        items: Array,
        maxItemNumber: Number,
        pending: Boolean,
        enableBarcodeSearch: {
            type: Boolean,
            default: true,
        },
        errorMessage: String,
    },
    template: require('./all-item-display-form.html'),
    data() {
        return {
            searchTextValue$: new Subject(),
            searchText: null as any,
            isBarcodeReaderActive: false,
            currentPageIndex: 0,
            selectedItemIndex: -1,

            // Icons
            loadingIcon: faCircleNotch,
            barcodeIcon: faBarcode,
        }
    },
    mounted() {
        this.subscribeTo(this.searchTextValue$.pipe(debounceTime(750)), searchText => {
            this.$emit('search', this.searchText, 0)
        })
        this.searchText = ''
    },
    computed: {
        lastPageIndex(): number {
            return Math.ceil((this.maxItemNumber as number) / PAGE_SIZE)
        },
    },
    methods: {
        incrementPageIndex() {
            this.currentPageIndex =
                this.currentPageIndex + 1 > this.lastPageIndex
                    ? this.lastPageIndex
                    : this.currentPageIndex + 1
            this.$emit('search', this.searchText, this.currentPageIndex)
        },
        decrementPageIndex() {
            this.currentPageIndex = this.currentPageIndex - 1 < 0 ? 0 : this.currentPageIndex - 1
            this.$emit('search', this.searchText, this.currentPageIndex)
        },
        toggleBarcodeReader() {
            this.isBarcodeReaderActive = !this.isBarcodeReaderActive
        },
        onBarcodeReaderInput(value: string) {
            this.searchText = value
            this.isBarcodeReaderActive = false
        },
        onItemSelected(item, index) {
            this.selectedItemIndex = index
            this.$emit('item-selected', { id: item.id, type: item.entityType || item.type })
        },
        getInventoryNumber(item: Item | Container): string {
            let inventoryNumber = itemSelectors.inventoryNumber(item as Item)
            if(inventoryNumber?.value) {
                inventoryNumber = inventoryNumber.value
            }

            return inventoryNumber
        },
        getTitle(item: Item | Container): string {
            return _.get(item, 'entityType', _.get(item, 'type'))
                .toLowerCase()
                .includes('container')
                ? containerSelectors.title(item as Container)
                : itemSelectors.title(item as Item, this.getAppLocale()) ?? ''
        },
        getFutureLocation(item: Item | Container): string {
            return _.get(item, 'entityType', _.get(item, 'type'))
                .toLowerCase()
                .includes('container')
                // @ts-ignore
                ? containerSelectors.futureLocation(item as Container)?.path
                : itemSelectors.futureLocation(item as Item)?.path
        },
    },
    watch: {
        searchText() {
            this.searchTextValue$.next(this.searchText)
        },
    },
})
